import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { MatColumnResizeModule } from '@angular/material-experimental/column-resize';
import { SharedModule } from '@shared/modules/shared.module';
import { XpKitModule } from '@shared/modules/xp-kit.module';
import { AppMaterialModule } from 'app/app-material.module';
import { OperatorDashboardComponent } from 'app/operator';
import { OperatorDatePickerModule } from './operator-date-picker.module';
import { OperatorReportsComponent } from 'app/operator/operator-reports/operator-reports.component';
import { OperatorFinanceComponent } from 'app/operator/operator-finance/operator-finance.component';
import { OperatorTransactionsComponent } from 'app/operator/operator-transactions/operator-transactions.component';
import { GetChartDataPipe } from 'app/components/operator/dashboard/get-chart-data.pipe';
import { GetIconPercentPipe } from 'app/components/operator/dashboard/get-icon-percent.pipe';
import { OperatorFinancePageComponent } from '../finance/operator-finance-page.component';

@NgModule({
	declarations: [
		OperatorDashboardComponent,
		OperatorReportsComponent,
		OperatorFinanceComponent,
		OperatorTransactionsComponent,
		GetChartDataPipe,
		GetIconPercentPipe,
		OperatorFinancePageComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		SharedModule,
		OperatorDatePickerModule,
		AppMaterialModule,
		MatRippleModule,
		MatColumnResizeModule,
		XpKitModule
	],
	exports: [
		OperatorDashboardComponent,
		OperatorReportsComponent,
		OperatorFinanceComponent,
		OperatorTransactionsComponent,
		GetChartDataPipe,
		GetIconPercentPipe,
		OperatorFinancePageComponent
	]
})
export class OperatorFeaturesSharedModule { }
